<app-main-nav-bar></app-main-nav-bar>
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-heading-accidents"></div>
      <div class="card-body">
        <h4 class="title">معرفی نامه</h4>
        <br>
        <br>
        <br>
        <br>
        <br>
        <app-custom-button [disabled]="false"
                           [BackButton]="true"
                           [LabelText]="'درخواست معرفی نامه'"
                           [Show]="true"
                           [backButtonLabel]="'معرفی نامه های من'"
                           [backUrl]="'/' + productName + '/requests'"
                           (OnClick)="create()"
        ></app-custom-button>
      </div>
    </div>
  </div>
</div>
